import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconGooglePlayStyle0 = cosmosIconCss;

const CosmosIconGooglePlay$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGooglePlay extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '79955752fdde4b31b1ef9770fe50bb1d8b5c17c9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '76071c36814046d54c597f7da9fc42a42d4e1efe', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '662a1a579087742cf8032435f730516bfbf81d0e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.417 18.438c-.257-.072-.425-.334-.425-.74V4.284c0-.376.142-.63.367-.723l6.42 7.475-6.362 7.4Zm.884-.285 7.726-4.497-1.881-2.19L6.3 18.152Zm7.78-9.795L6.462 3.924l5.695 6.673 1.924-2.239Zm.516.301 2.985 1.737c.565.33.57.86 0 1.192l-3.06 1.78-1.996-2.338 2.071-2.37Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconGooglePlayStyle0; }
}, [1, "cosmos-icon-google-play", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-play"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-play":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGooglePlay$1);
            }
            break;
    } });
}

const CosmosIconGooglePlay = CosmosIconGooglePlay$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGooglePlay, defineCustomElement };
